import { normalizePathname, getBaseProductRoute } from './productNavigation';
import { getCarBrandDisplayName } from './carBrand';

export const BREADCRUMBS = {
  '/car-insurance-quote': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Car Insurance' },
  ],
  '/car-insurance-quote/companies': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Car Insurance', href: '/car-insurance-quote' },
    { label: 'Companies' },
  ],
  '/funeral-insurance-quote': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Funeral Insurance' },
  ],
  '/life-insurance-quote': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Life Insurance' },
  ],
  '/life-insurance-quote/life-insurance-companies': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Life Insurance', href: '/life-insurance-quote' },
    { label: 'Companies' },
  ],
  '/medical-aid-quote': [
    { label: 'Home', href: '/' },
    { label: 'Health', href: '/health' },
    { label: 'Medical Aid' },
  ],
  '/medical-aid-quote/medical-aid-companies': [
    { label: 'Home', href: '/' },
    { label: 'Health', href: '/health' },
    { label: 'Medical Aid', href: '/medical-aid-quote' },
    { label: 'Schemes' },
  ],
  '/pet-insurance-quote': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Pet Insurance' },
  ],
  '/motor-warranty': [
    { label: 'Home', href: '/' },
    { label: 'Motor', href: '/motor/' },
    { label: 'Motor Warranty' },
  ],
  '/dents-and-scratches-quote': [
    { label: 'Home', href: '/' },
    { label: 'Motor', href: '/motor/' },
    { label: 'Scratch and Dent Cover' },
  ],
  '/travel-insurance': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Travel Insurance' },
  ],
  '/medical-gap-cover-quote': [
    { label: 'Home', href: '/' },
    { label: 'Health', href: '/health' },
    { label: 'Gap Cover' },
  ],
  '/medical-insurance-quotes': [
    { label: 'Home', href: '/' },
    { label: 'Health', href: '/health' },
    { label: 'Medical Insurance' },
  ],
  '/buildings-insurance-quote': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Buildings Insurance' },
  ],
  '/business-insurance-quote': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Business Insurance' },
  ],
  '/service-plan-quotes': [
    { label: 'Home', href: '/' },
    { label: 'Motor', href: '/motor/' },
    { label: 'Service Plans' },
  ],
  '/vehicle-tracking-quote': [
    { label: 'Home', href: '/' },
    { label: 'Motor', href: '/motor/' },
    { label: 'Vehicle Tracking' },
  ],
  '/tyre-and-rim-guard': [
    { label: 'Home', href: '/' },
    { label: 'Motor', href: '/motor/' },
    { label: 'Tyre and Rim Cover' },
  ],
  '/compare-fibre-deals': [
    { label: 'Home', href: '/' },
    { label: 'Internet', href: '/internet' },
    { label: 'Home Fibre Deals' },
  ],
  '/motorcycle-insurance-quote': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Motorbike Insurance' },
  ],
  '/home-insurance-quote': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Home Contents Insurance' },
  ],
  '/personal-loans': [
    { label: 'Home', href: '/' },
    { label: 'Money', href: '/money/' },
    { label: 'Personal Loans' },
  ],
  '/debt-counselling': [
    { label: 'Home', href: '/' },
    { label: 'Money', href: '/money/' },
    { label: 'Debt Counselling' },
  ],
  '/debt-consolidation-loans': [
    { label: 'Home', href: '/' },
    { label: 'Money', href: '/money/' },
    { label: 'Debt Consolidation Loans' },
  ],
  '/business-insurance-quote/car-and-commercial-property-insurance': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Business Insurance', href: '/business-insurance-quote' },
    { label: 'Car & Commercial Property Insurance' },
  ],
  '/employee-benefits-quote': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Business Insurance', href: '/business-insurance-quote' },
    { label: 'Employee Benefits' },
  ],
  '/business-insurance-quote/business-legal-cover': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Business Insurance', href: '/business-insurance-quote' },
    { label: 'Business Legal Cover' },
  ],
  '/business-insurance-quote/professional-liability-insurance-cover': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Business Insurance', href: '/business-insurance-quote' },
    { label: 'Professional Liability Insurance' },
  ],
  '/business-insurance-quote/event-liability-insurance': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Business Insurance', href: '/business-insurance-quote' },
    { label: 'Event Liability Cover' },
  ],
  '/car-insurance-quote/south-african-car-guide': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Car Insurance', href: '/car-insurance-quote' },
    { label: 'Car Guide' },
  ],
  '/compare-savings-accounts-online': [
    { label: 'Home', href: '/' },
    { label: 'Compare savings accounts' },
  ],
  '/insurance': [{ label: 'Home', href: '/' }, { label: 'Insurance' }],
  '/motor': [{ label: 'Home', href: '/' }, { label: 'Motor' }],
  '/health': [{ label: 'Home', href: '/' }, { label: 'Health' }],
  '/money': [{ label: 'Home', href: '/' }, { label: 'Money' }],
  '/internet': [{ label: 'Home', href: '/' }, { label: 'Internet' }],
};

// Fallback label formatter for slugs that don't have a known title yet
// (e.g. a page missing from the approved breadcrumb sheet). Mirrors
// scripts/generate-sitemap.js.
const slugToLabel = (slug = '') =>
  slug
    .replace(/-quote\d*$/, '')
    .replace(/-quotes?$/, '')
    .split('-')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

// Sections whose page titles are proper names — a company, a car brand, a car
// model — rather than sentences. Their labels are rendered exactly as authored
// in Contentful instead of being sentence-cased, so a new partner or model
// page reads correctly the day it is published, with nothing to add here.
const PROPER_NAME_SECTIONS = [
  '/partners',
  '/car-insurance-quote/south-african-car-guide',
];

const isProperNameSection = (pathname) => {
  const normalized = normalizePathname(pathname);
  return PROPER_NAME_SECTIONS.some(
    (section) => normalized.startsWith(`${section}/`) && normalized !== section
  );
};

// Crumbs carry `exact: true` when their label is already in the casing it
// should appear in — the curated BREADCRUMBS table above, or a proper name
// from one of the sections listed below. BreadcrumbComponent renders those
// verbatim; every other label goes through toSentenceCase.
const asExact = (crumb) => ({ ...crumb, exact: true });

// A slug inside a proper-name section is a brand or model name, so it is
// un-slugged rather than sentence-cased: "mercedes-benz" -> "Mercedes-Benz",
// "bmw" -> "BMW". Known car brands keep their registered display casing; the
// rest fall back to title-casing each word.
const slugToProperName = (slug = '') => {
  const brand = getCarBrandDisplayName(slug);
  if (brand) return brand;

  return slug
    .split('-')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const LAUNCH_PAD_TYPES = ['launch-pad', 'launch-pad-guide-partner'];

const cleanLabel = (value) =>
  String(value ?? '')
    .replace(/\n/g, ' ')
    .trim() || null;

// The final-crumb label for a spin-off, partner or car guide page, read from
// the launch pad item in its Contentful `config`: an optional
// `breadcrumbTitle` there wins, otherwise its `heading` is used. Pages without
// a launch pad use their first config item instead. Returns null when neither
// is set so getBreadcrumbs falls back to the slug.
export const getBreadcrumbTitle = (config) => {
  const items = Array.isArray(config) ? config : [config];
  const launchPad =
    items.find((item) => LAUNCH_PAD_TYPES.includes(item?.type)) ?? items[0];
  return (
    cleanLabel(launchPad?.breadcrumbTitle) || cleanLabel(launchPad?.heading)
  );
};

// Resolves breadcrumbs for any URL, including nested blog/spin-off pages that
// aren't explicitly listed in BREADCRUMBS above. It walks up to the nearest
// known parent route (e.g. /car-insurance-quote for
// /car-insurance-quote/premiums-by-age/) then adds one crumb per remaining
// URL segment, however deep — so
// /car-insurance-quote/south-african-car-guide/chery/chery-cross/ becomes
// Car Insurance > Car Guide > Chery > Chery Cross, each level linking to its
// own page. Intermediate segments are labeled from the slug itself; only the
// final segment uses `currentLabel` (e.g. a Contentful page heading) when
// provided.
//
// Standalone dynamic pages (e.g. partner pages living at a top-level slug
// with no matching product route, like /some-partner-name/) have no known
// parent to walk up to — those still get a Home > <page title> breadcrumb
// rather than none at all.
export const getBreadcrumbs = (pathname, currentLabel) => {
  const normalized = normalizePathname(pathname);

  if (BREADCRUMBS[normalized]) return BREADCRUMBS[normalized].map(asExact);

  const baseRoute = getBaseProductRoute(normalized);
  const hasKnownParent = Boolean(BREADCRUMBS[baseRoute]);
  const parentCrumbs = hasKnownParent
    ? BREADCRUMBS[baseRoute]
    : [{ label: 'Home', href: '/' }];

  const baseSegments = hasKnownParent
    ? baseRoute.split('/').filter(Boolean)
    : [];
  const allSegments = normalized.split('/').filter(Boolean);
  const remainingSegments = allSegments.slice(baseSegments.length);
  if (!remainingSegments.length) return parentCrumbs.map(asExact);

  const trailingCrumbs = remainingSegments.map((segment, index) => {
    const isLast = index === remainingSegments.length - 1;
    const path = `/${[
      ...baseSegments,
      ...remainingSegments.slice(0, index + 1),
    ].join('/')}`;

    // A crumb already covered by the curated table (e.g. the Car Guide index
    // sitting above the brand pages) uses that table's label.
    const curated = BREADCRUMBS[path];
    const curatedLabel = curated?.[curated.length - 1]?.label;

    if (!isLast) {
      if (curatedLabel) return asExact({ label: curatedLabel, href: path });
      return isProperNameSection(path)
        ? asExact({ label: slugToProperName(segment), href: path })
        : { label: slugToLabel(segment), href: path };
    }

    const heading = String(currentLabel || '')
      .replace(/\n/g, ' ')
      .trim();

    if (isProperNameSection(path)) {
      return asExact({ label: heading || slugToProperName(segment) });
    }

    return { label: heading || slugToLabel(segment) };
  });

  return [
    ...parentCrumbs.map((crumb, index) =>
      asExact(
        hasKnownParent && index === parentCrumbs.length - 1
          ? { ...crumb, href: baseRoute }
          : crumb
      )
    ),
    ...trailingCrumbs,
  ];
};
